import { React } from "react";
import { InputGroup } from "./ProductForm.styled";
import PropTypes from "prop-types";

// eslint-disable-next-line react/prop-types
export const Input = ({
	status,
	title,
	handleChange,
	type,
	name,
	value,
	backGroundColor,
}) => {
	return (
		<InputGroup status={status}>
			<label htmlFor={name}>{title}</label>
			<input
				className={backGroundColor}
				disabled={status}
				onChange={handleChange}
				value={value}
				type={type}
				name={name}
			/>
		</InputGroup>
	);
};

// eslint-disable-next-line react/prop-types
export const DataListInput = ({
	status,
	name,
	title,
	options,
	handleChange,
	value
}) => {
	return (
		<InputGroup status={status}>
			<label>{title}</label>
			<input disabled={status} list={name} name={name} onChange={handleChange} value={value} />
			<datalist id={name}>
				{options.map((duration) => {
					return <option key={duration} value={duration} />;
				})}
			</datalist>
		</InputGroup>
	);
};

Input.propTypes = {
	status: PropTypes.bool,
	title: PropTypes.string,
	handleChange: PropTypes.func,
	type: PropTypes.string,
	name: PropTypes.string,
	value: PropTypes.string,
	backGroundColor: PropTypes.string,
};

DataListInput.propTypes = {
	status: PropTypes.bool,
	title: PropTypes.string,
	handleChange: PropTypes.func,
	type: PropTypes.string,
	name: PropTypes.string,
	value: PropTypes.string,
	backGroundColor: PropTypes.string,
	options: PropTypes.array,
};
